export default {
	title: "Rituels",
	dateTime: "Date et heure",
	notFinished: "Non terminé",
	edit: "Modifier le rituel",
	create: "Créer un rituel",
	notFound: "Rituel introuvable",
	loading: "Chargement du rituel...",
	createdBy: "Créé par",
	deleteConfirmation: "Voulez-vous vraiment supprimer le rituel {title} ?",
	deleteWarning: "Toutes les fiches, retours et messages liés à ce rituel seront définitivement supprimés.",
	deleteCodeInstruction: "Pour confirmer, saisissez le code {code} :",
	startWarning: "Une fois commencé, les fiches pourront être distribuées et appelées.",
	startCodeInstruction: "Pour confirmer, saisissez le code {code} :",
	status: {
		label: "Statut",
		scheduled: "Programmé",
		inProgress: "En cours",
		in_progress: "En cours",
		completed: "Terminé",
		cancelled: "Annulé",
		closed: "Clôturé",
	},
	form: {
		titleLabel: "Titre du rituel",
		titleHint: "Titre qui identifie le rituel",
		descriptionLabel: "Description",
		descriptionHint: "Description détaillée du rituel",
		ritualTypeLabel: "Type de rituel",
		ritualTypeHint: "Sélectionnez le type de rituel",
		statusLabel: "Statut",
		statusHint: "Statut actuel du rituel",
		dateLabel: "Date",
		dateHint: "Date à laquelle le rituel aura lieu",
		startTimeLabel: "Heure de début",
		startTimeHint: "Heure de début du rituel (obligatoire)",
		startDateLabel: "Date et heure de début",
		endDateLabel: "Date et heure de fin",
		locationLabel: "Lieu",
		locationHint: "Lieu où se déroulera le rituel",
		isPublicLabel: "Publier dans l'agenda public",
		isPublicHint: "Rend ce rituel visible sur la page publique du temple",
		acceptsReservationsLabel: "Accepter les réservations",
		acceptsReservationsHint: "Permet aux personnes de réserver une place pour ce rituel",
		publicNotesLabel: "Notes publiques",
		publicNotesHint: "Texte affiché dans l'agenda public (optionnel)",
		retroactiveWarning:
			"Date passée : ce rituel sera créé comme saisie rétroactive. Il naît au statut Planifié — ajoutez les fiches et utilisez \"Clôturer le rituel\" pour l'enregistrer, sans avoir besoin de le démarrer.",
	},
	retroactive: {
		badge: "Saisie rétroactive",
	},
	table: {
		headers: {
			title: "Titre",
			public: "Public",
		},
		public: {
			yes: "Dans l'agenda public",
			no: "Non publié",
		},
		title: "Titre",
	},
	tabs: {
		tickets: "Cartes de présence",
		stats: "Statistiques",
		details: "Détails",
		report: "Rapport",
		messages: "Messages",
		returns: "Retours",
	},
	lists: {
		pdf: "PDF",
		xlsx: "XLSX",
		sortCreated: "Ordre de création",
		sortTarget: "Ordre de destination",
		sortAlpha: "Ordre alphabétique",
		messagesEmpty: "Aucun message enregistré pour ce rituel",
		returnsEmpty: "Aucun retour lié à ce rituel",
		groupEmpty: "Aucun retour dans ce groupe",
		createdHere: "Créés dans ce rituel",
		fulfilledHere: "Accomplis dans ce rituel",
		markedHere: "Marqués pour ce rituel",
		createdBy: "Créé par",
	},
	actions: {
		delete: "Supprimer",
		start: "Démarrer",
		complete: "Terminer",
		cancel: "Annuler",
	},
	filters: {
		search: "Rechercher des rituels...",
		date: "Date",
		today: "Aujourd'hui",
		thisWeek: "Cette semaine",
		thisMonth: "Ce mois-ci",
		dateFrom: "Date de début",
		dateTo: "Date de fin",
		status: "Statut",
		ritualType: "Type de rituel",
	},
	details: {
		ritualType: "Type de rituel",
		noTicketsDescription: "Aucune carte de présence enregistrée pour ce rituel",
	},
	messages: {
		created: "Rituel '{title}' créé avec succès",
		updated: "Rituel '{title}' mis à jour avec succès",
		deleted: "Rituel '{title}' supprimé avec succès",
		statusUpdated: "Le statut du rituel '{title}' a été changé en {status}",
		createError: "Erreur lors de la création du rituel",
		updateError: "Erreur lors de la mise à jour du rituel",
		deleteError: "Erreur lors de la suppression du rituel",
		statusUpdateError: "Erreur lors de la mise à jour du statut du rituel",
		loadError: "Erreur lors du chargement des rituels",
		editDisabled: "Les rituels terminés ou annulés ne peuvent pas être modifiés",
		deleteDisabled: "Les rituels annulés, en cours ou terminés ne peuvent pas être supprimés",
		cancelDisabled: "Les rituels annulés ou terminés ne peuvent pas être annulés",
		startDisabled: "Seuls les rituels programmés peuvent être démarrés",
	},
	confirmStatusChange: "Confirmer le changement de statut",
	statusChangeConfirmation: "Êtes-vous sûr de vouloir changer le statut du rituel '{title}' en {status} ?",
	confirmations: {
		start: "Êtes-vous sûr de vouloir démarrer ce rituel ?",
		complete: "Êtes-vous sûr de vouloir terminer ce rituel ?",
		cancel: "Êtes-vous sûr de vouloir annuler ce rituel ? Cette action est irréversible.",
		delete: "Êtes-vous sûr de vouloir supprimer le rituel '{title}' ? Cette action est irréversible.",
	},
	empty: {
		title: "Aucun rituel trouvé",
		subtitle: "Créez le premier rituel dans le système",
		button: "Créer un rituel",
		dependencyWarning: "Pour créer des rituels, vous devez d'abord enregistrer des types de présence et des types de rituels.",
	},
	stats: {
		total: "Total",
		scheduled: "Programmés",
		inProgress: "En cours",
		completed: "Terminés",
		cancelled: "Annulés",
		acceptableLimit: "Limite (15 min)",
		attendanceTime: "Durée de présence par poste",
		avgTime: "Durée moyenne",
		loadError: "Erreur lors du chargement des statistiques",
		minutes: "minutes",
		noTickets: "Aucune fiche enregistrée pour ce rituel",
		noTicketsSubtitle: "Les statistiques apparaîtront lorsque les fiches seront distribuées",
		pending: "En attente",
		perCardBreakdown: "Fiches par poste de présence",
		statusDistribution: "Distribution des statuts",
		tickets: "fiches",
	},
	validation: {
		titleRequired: "Le titre est obligatoire",
		titleMaxLength: "Le titre doit avoir au maximum 100 caractères",
		ritualTypeRequired: "Le type de rituel est obligatoire",
		dateRequired: "La date est obligatoire",
		startTimeRequired: "L'heure de début est obligatoire",
		locationMaxLength: "Le lieu doit avoir au maximum 200 caractères",
		descriptionMaxLength: "La description doit avoir au maximum 500 caractères",
		publicNotesMaxLength: "Les notes publiques doivent avoir au maximum 500 caractères",
		activeRitualExists: "Il y a déjà un rituel en cours. Un seul rituel peut être actif à la fois.",
		invalidTime: "Format d'heure invalide",
		statusRequired: "Le statut est obligatoire",
	},
};
